import Guid from "common/values/guid/guid";
import Action from "notifications/values/action/action";
import NotificationMessage from "notifications/values/notification-message/notification-message";
import NotificationTopic from "notifications/values/notification-topic/notification-topic";
import Notification from 'notifications/entities/notification/notification';
import { Moment } from "moment";
import MessageInfo from "notifications/entities/message-info/message-info";
import NotificationRecipient from "notifications/values/notification-recipient/notification-recipient";


export default class MessageNotification extends Notification {
  messageInfo?: MessageInfo;

  constructor(
    id: Guid,
    recipients?: NotificationRecipient[],
    senderUserId?: Guid,
    message?: NotificationMessage,
    topic?: NotificationTopic | null,
    actionRequired?: Action,
    createdDate?: Moment,
    messageInfo?: MessageInfo
  ) {
    super(
      id,
      recipients,
      senderUserId,
      message,
      topic,
      actionRequired,
      createdDate
    );

    this.messageInfo = messageInfo;
  }
}
